import { useState } from "react";
import HttpServices from "src/services/httpService";
import { integrateModuleURL } from "src/services/urlService";
import { useToaster } from "src/utils/toaster/toasterContext";
import BlueskyAuthorizationModal from "../blueskyIntegration/blueskyAuthorizationModal";
import { useTranslation } from "react-i18next";
import { useResellerLimitDialog } from 'src/components/reseller-limit-context/resellerLimitContext';

const BlueskyReAuthenticate = ({ handleClose,AccountId, getConnectedNetworks }) => {
  const { t: translate } = useTranslation();
  const { showResellerLimitDialog } = useResellerLimitDialog();

  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [isLoadingOn, setLoadingOn] = useState(false);

  const { showToast } = useToaster();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'identifier') {
      setIdentifier(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };

  const blueskyIntegrationSuccessCallback = (data, message) => {
    setLoadingOn(false);
    showToast(message, 's');
    getConnectedNetworks();
    handleCloseBluesky();
  };

  const blueskyIntegrationFailureCallback = (message) => {
    setLoadingOn(false);
    if (!showResellerLimitDialog(message)) {
      message && showToast(message, 'e');
    }
  };

  const sendBlueskyCredentialsToServer = () => {
    if (!identifier || !password) {
      showToast(translate("bluesky.enter_all_fields"), 'e');
      return;
    }

    setLoadingOn(true);

    const blueskyForm = {
      identifier: identifier.trim(),
      password: password,
      account_id: AccountId
    };

    const postProps = {
      url: integrateModuleURL.reAuthenticateBluesky,   // ← Change this URL in urlService
      body: blueskyForm,
      successCallback: blueskyIntegrationSuccessCallback,
      failureCallback: blueskyIntegrationFailureCallback
    };

    HttpServices.Post(postProps);
  };

  const handleCloseBluesky = () => {
    setAuthorizationModal(false);
    handleClose();
  };

  return (
    isAuthorizationModalOpen && (
      <BlueskyAuthorizationModal
        handleBlueskyConnect={sendBlueskyCredentialsToServer}
        handleClose={handleCloseBluesky}
        handleInputChange={handleInputChange}
        identifier={identifier}
        password={password}
        isLoadingOn={isLoadingOn}
      />
    )
  );
};

export default BlueskyReAuthenticate;